/* eslint-disable import-helpers/order-imports */
/* eslint-disable react/require-default-props */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useField } from '@unform/core';

import { Value } from 'react-time-picker/dist/cjs/shared/types';

import 'react-time-picker/dist/TimePicker.css';

import { getSeconds } from '~/utils';

import { StyledTimeInput } from './styles';

type Props = {
  defaultValue?: string;
  disabled?: boolean;
  clearIcon?: string | null;
  name?: string;
  setValue?: React.Dispatch<React.SetStateAction<number>>;
  onChange?: () => void;
};

const TimeInput = ({
  defaultValue,
  disabled,
  clearIcon,
  name,
  setValue,
  onChange,
  ...rest
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const unform = useField(name || ' ');

  const [inputValue, setInputValue] = useState<string>(defaultValue as string);

  const handleUpdateValues = useCallback(
    (e: Value) => {
      setInputValue(e as string);
      onChange ? onChange() : setValue && setValue(getSeconds(e as string));
    },
    [setValue, onChange],
  );

  useEffect(() => {
    handleUpdateValues(defaultValue as Value);
  }, [defaultValue, handleUpdateValues]);

  useEffect(() => {
    handleUpdateValues(inputValue);
  }, [inputValue, handleUpdateValues]);

  useEffect(() => {
    if (name) {
      unform.registerField({
        name: unform.fieldName,
        ref: inputRef.current,
        path: 'value',
        setValue: (ref, value: string) => {
          setInputValue(value);
        },
      });
    }
  }, [name, unform]);

  return (
    <>
      <StyledTimeInput
        disableClock
        clearIcon={clearIcon}
        value={inputValue}
        onChange={(time) => {
          const value = time === null ? '00:00:00' : String(time);

          setInputValue(value);
        }}
        maxDetail="second"
        format="HH:mm:ss"
        locale="pt-BR"
        disabled={disabled}
        name={name}
        {...rest}
      />
      <input
        style={{ display: 'none' }}
        disabled
        value={inputValue}
        ref={inputRef}
        name={name}
      />
    </>
  );
};

export default TimeInput;
